import { API } from '../constants';
import CLIENT from './client';
import {
  DownloadFormQuery,
  FormDTO,
  GetFormQueryDto,
  UpdateFormBodyDto,
  AuditLogEntryDTO,
} from '@/interfaces';
import * as qs from 'qs';

export const createForm = (body: Omit<FormDTO, '_id' | 'creator'>) => {
  return CLIENT.post(API.FORMS, body);
};

export const getForm = (id: string) => {
  return CLIENT.get(API.FORM(id));
};

// NOTE (2026-09-09, audit trail - stage 2 of 3): new read-only call for
// the "Change History" panel. Does not change getForm/updateForm above.
// NOTE (2026-09-09, bug fix): every backend response is wrapped globally
// in `{ statusCode, data }` by ResponseInterceptor (see how getForm's
// caller unwraps `payload.data` in store/slices/form.ts) - so the axios
// response body here is `{ statusCode, data: AuditLogEntryDTO[] }`, not a
// bare array. The type below reflects that; ChangeHistorySection unwraps
// `response.data.data`.
export const getFormAuditLog = (id: string) => {
  return CLIENT.get(API.FORM_AUDIT_LOG(id)) as Promise<{
    data: { statusCode: number; data: AuditLogEntryDTO[] };
  }>;
};

export const getForms = (params: GetFormQueryDto) => {
  return CLIENT.get(API.FORMS, params as JSON);
};

export const updateForm = (body: UpdateFormBodyDto) => {
  return CLIENT.patch(API.FORM(body._id), body);
};

export const deleteForm = (id: string) => {
  return CLIENT.delete(API.FORM(id));
};

export const downloadForms = (query?: DownloadFormQuery) => {
  const stringifyQuery = query ? qs.stringify(query, { arrayFormat: 'comma' }) : '';
  return CLIENT.download(`${API.FORM_DOWNLOAD}?${stringifyQuery}`).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const filename = response.headers['content-disposition']
      .split('; ')[1]
      .replace(/"|\\/g, '')
      .replace('filename=', '');
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename); //or any other extension
    document.body.appendChild(link);
    link.click();
  });
};

// NOTE (2026-09-09, audit trail - stage 3 of 3): separate CSV download of
// a single form's audit trail - independent from downloadForms() above
// (which still exports only current CIOMS/Pregnancy/SAE_AESI/Adverse
// Event data, unchanged). Mirrors downloadForms()'s blob/filename
// handling exactly.
export const downloadFormAuditLog = (id: string) => {
  return CLIENT.download(API.FORM_AUDIT_LOG_DOWNLOAD(id)).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const filename = response.headers['content-disposition']
      .split('; ')[1]
      .replace(/"|\\/g, '')
      .replace('filename=', '');
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
  });
};
